import { Component, Event, EventEmitter, h, Host, Prop, State } from '@stencil/core';

@Component({
  tag: 'mama-gallery-item',
  styleUrl: './mama-gallery-item.scss',
})
export class MamaGalleryItem {
  @Event() mamaGalleryItemClicked: EventEmitter;

  @Prop() layerHeadline!: string;
  @Prop() layerText!: string;
  @State() showLayer = false;

  itemClicked() {
    this.mamaGalleryItemClicked.emit();
  }

  render() {
    return (
      <Host onClick={() => this.itemClicked()}>
        <div class="layer">
          <strong>{this.layerHeadline}</strong>
          <span>{this.layerText}</span>
        </div>
        <div class="gallery-item">
          <div class="search-icon">
            <svg class="search-plus">
              <use xlinkHref="#search-plus"></use>
            </svg>
          </div>
          <slot name="picture" />
          <slot name="preview" />
          <slot name="description" />
        </div>
      </Host>
    );
  }
}
